const { scopeKey, issue, result } = require("./contracts");
const { storedDecimal, format } = require("./decimal");
const { validateHierarchy } = require("./hierarchy");

const validateVatProtections = (source, options) => {
  const hierarchy = validateHierarchy(source, options);
  if (!hierarchy.valid) return { ...hierarchy, tax: null };
  const { graph } = hierarchy, errors = [], summaries = new Map(), leafRates = [];
  const incomplete = new Set(graph.incompleteIds), incompleteSubtree = new Set();
  // A mixed summary keeps two witnesses, not a falsely exhaustive rate list.
  // This is sufficient to prove heterogeneity and keeps deeply nested trees O(n).
  for (let index = graph.nodes.length - 1; index >= 0; index -= 1) {
    const node = graph.nodes[index];
    const witnesses = new Set();
    if (node.economic) {
      const rate = storedDecimal(node.vatRate, 7, 4);
      if (!rate) errors.push(issue("QUOTE_COMPOSITION_INVALID_VAT", "Taux de feuille positif ou nul, représentable en DECIMAL(7,4), requis.",
        { lineId: node.id, parentLineId: node.parentLineId, scope: graph.scope, path: ["lines", node.sourceIndex, "vatRate"] }));
      else { witnesses.add(format(rate)); leafRates.push({ lineId: node.id, vatRate: format(rate) }); }
    }
    for (const childId of node.childIds) {
      for (const rate of summaries.get(childId).rateWitnesses) { if (witnesses.size < 2) witnesses.add(rate); }
    }
    if (incomplete.has(node.id) || node.childIds.some((childId) => incompleteSubtree.has(childId))) incompleteSubtree.add(node.id);
    const rates = [...witnesses].sort();
    const summary = { lineId: node.id, classification: rates.length === 0 ? "empty" : rates.length === 1 ? "homogeneous" : "mixed",
      homogeneousRate: rates.length === 1 ? rates[0] : null, rateWitnesses: rates };
    summaries.set(node.id, summary);
    if (node.structureKind === "composite" && node.sellingPriceMode === "forced") {
      if (rates.length === 0 || incompleteSubtree.has(node.id)) {
        errors.push(issue("QUOTE_COMPOSITION_INCOMPLETE", "Un ensemble forcé doit contenir une feuille économique valide.",
          { lineId: node.id, parentLineId: node.parentLineId, scope: graph.scope }, 422));
      } else if (rates.length > 1) errors.push(issue("QUOTE_COMPOSITION_MIXED_VAT_FORCING", "Forçage interdit : les feuilles du sous-arbre ne partagent pas le même taux.",
        { lineId: node.id, parentLineId: node.parentLineId, scope: graph.scope, rateWitnesses: rates }, 422));
    }
  }
  return result(errors, { graph, tax: { leafRates: leafRates.reverse(), nodes: graph.nodes.map((node) => summaries.get(node.id)) } });
};

// B3 will call this on a candidate loaded under its own transaction/revision guard.
// Neither state is mutated, persisted, reset or recalculated here.
const validateVatMutation = (before, candidate, options) => {
  const previous = validateVatProtections(before, options);
  if (!previous.valid) return { ...previous, phase: "before" };
  if (String(before.quoteVersionId) !== String(candidate?.quoteVersionId)
    || scopeKey(previous.graph.scope) !== scopeKey(candidate?.scope)) {
    return result([issue("QUOTE_COMPOSITION_SCOPE_MISMATCH", "Une mutation TVA ne traverse pas une version ou un périmètre.")], { graph: null, tax: null, phase: "candidate" });
  }
  const next = validateVatProtections(candidate, options);
  const previousForced = new Set(previous.graph.nodes.filter((node) => node.structureKind === "composite"
    && node.sellingPriceMode === "forced").map((node) => node.id));
  return { ...next, errors: next.errors.map((error) => error.code === "QUOTE_COMPOSITION_MIXED_VAT_FORCING"
    && previousForced.has(error.lineId) ? { ...error, code: "QUOTE_COMPOSITION_FORCED_VAT_CONFLICT" } : error), phase: "candidate" };
};
module.exports = { validateVatProtections, validateVatMutation };
